import { BuyMoreOffer } from '@app/redux/buyMore';

import ProductCard from './ProductCard';
import ProductCardLoading from './ProductCardLoading';

import styles from './styles.module.scss';

type ProductListProps = {
  loading: boolean;
  products: BuyMoreOffer[];
};

const ProductList = (props: ProductListProps): JSX.Element => {
  const { loading, products } = props;

  return (
    <div data-cy="product-list" className={styles['list']}>
      {loading ? (
        <>
          <ProductCardLoading />
          <ProductCardLoading />
        </>
      ) : (
        products.map((product: BuyMoreOffer) => <ProductCard key={product.id} product={product} />)
      )}
    </div>
  );
};

export default ProductList;
